import React, { useEffect } from "react";

/* 30px Bloomberg-style tab bar — uppercase 10.5px labels, kbd hints
   1/2/3/4. Activates on click or keyboard. The handoff README pins
   the tab order as Overview / Pay / Receive / Treasury and treats
   Settings as out of scope (we move it into the util-bar dropdown).

   `tabs` is an array of { id, label, kbd?, badge? } so callers can
   gate visibility on permissions without this component knowing
   about config. */

export default function TabBar({ tabs, activeId, onChange, sessionLabel }) {
  useEffect(() => {
    const onKey = (e) => {
      const tag = document.activeElement?.tagName;
      if (tag === "INPUT" || tag === "SELECT" || tag === "TEXTAREA") return;
      if (e.metaKey || e.ctrlKey || e.altKey) return;
      const k = e.key;
      const match = tabs.find((t) => String(t.kbd || "") === k);
      if (match) {
        e.preventDefault();
        onChange?.(match.id);
      }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [tabs, onChange]);

  return (
    <div className="term-tabbar" role="tablist">
      {tabs.map((t) => (
        <button
          key={t.id}
          role="tab"
          aria-selected={activeId === t.id}
          className={"term-tab" + (activeId === t.id ? " is-active" : "")}
          onClick={() => onChange?.(t.id)}
        >
          {t.kbd != null && <span className="term-tab-kbd">{t.kbd}</span>}
          <span>{t.label}</span>
          {t.badge ? (
            <span className="term-tab-kbd" style={{ color: "var(--term-amber)" }}>{t.badge}</span>
          ) : null}
        </button>
      ))}
      <div className="term-tab-spacer" />
      {sessionLabel ? <div className="term-tab-meta">{sessionLabel}</div> : null}
    </div>
  );
}
